import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { environment } from "src/environments/environment";

export function testEnvPasswordGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        if (environment.testEnvGuardActive !== true || state.url.includes("/pwd-guard")) {
            return true;
        }
        const pwd = sessionStorage.getItem("testEnvPwd");
        if (pwd !== environment.testEnvGuardPwd) {
            const router: Router = inject(Router);
            router.navigate(["/pwd-guard", state.url]);
            return false;
        }
        return true;
    };
}
